var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',{staticClass:"row"},[_c('PageHeader',{staticClass:"col-11",attrs:{"title":"RPO Dashboard"}})],1),_c('AllIncident')],1)}
var staticRenderFns = []

export { render, staticRenderFns }